module.exports = __webpack_public_path__ + "img/banner-3.5d577996.png";